import React, { useCallback } from 'react';

import { InfiniteTable } from 'modules/experience-core';

import { ReviewsTableProps, ReviewTableItem } from './hooks/useRatingsByVenueTableProps';
import { preservePeriodParam } from '../../hooks/useInsightsSubRoutes';

export const RatingsByVenueTable = ({
  className,
  items,
  fetchingNextPage,
  fetchingPreviousPage,
  sort,
  onFetchNextPage,
  onFetchPreviousPage,
  columns,
}: ReviewsTableProps) => {
  const link = useCallback(
    (record: ReviewTableItem) => preservePeriodParam(`/venue/${record.id}/insights/ratings`),
    [],
  );

  return (
    <InfiniteTable.Root
      link={link}
      className={className}
      items={items}
      fetchingNextPage={fetchingNextPage}
      fetchingPreviousPage={fetchingPreviousPage}
      onFetchNextPage={onFetchNextPage}
      onFetchPreviousPage={onFetchPreviousPage}
      sort={sort}
      visibleRowsCount={10}
      columns={columns}
    />
  );
};
